import React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error } from '@progress/kendo-react-labels';
import BaseTextArea from '../inputs/BaseTextArea';

/**
 * @deprecated Use /shared/components/formControls components instead.
 */
const FormTextArea = (fieldRenderProps) => {
  const {
    validationMessage,
    visited,
    label,
    id,
    valid,
    disabled,
    type,
    optional,
    readOnly,
    ...others
  } = fieldRenderProps;

  const showValidationMessage = visited && validationMessage;
  const errorId = showValidationMessage ? `${id}_error` : '';

  return (
    <FieldWrapper>
      <div className="k-form-field-wrap">
        {label && <Label
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          optional={optional}
          {...(readOnly ? { className: 'label-readonly' } : {})}
        >
          {label}
        </Label>
        }
        <BaseTextArea
          valid={valid}
          type={type}
          id={id}
          disabled={disabled}
          ariaDescribedBy={errorId}
          readOnly={readOnly}
          {...others}
        />
        {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )}
      </div>
    </FieldWrapper>
  );
};

export default FormTextArea;
